import {
    insightAreaUpdateModel,
    insightAreaUpdateImage,
} from "../../../actions/insight-area-actions"

import buildItemConnector from "../../common/build-item-connector"

export default buildItemConnector(
    "insightAreas",
    false,
    insightAreaUpdateModel,
    insightAreaUpdateImage
)
